import { Avatar } from "@certa/catalyst/components/Avatar";
import { Stack } from "@certa/catalyst/layouts/Stack";
import { CatalystColors } from "@certa/catalyst/constants/styles";

import { App } from "@certa/icons/components/App";

import styles from "./DataObjectLogo.module.css";

type DataObjectLogoProps = {
  logo?: string | null;
  objectName: string;
};

export const DataObjectLogo = (props: DataObjectLogoProps) => {
  const { logo, objectName } = props;

  // Extract file_url query param from logo URL if present, otherwise
  // use full logo URL. This handles both unauthenticated (file_url param)
  // and authenticated file downloads (full logo URL).
  const logoUrl = logo
    ? logo?.includes("file_url")
      ? (new URL(logo).searchParams.get("file_url") ?? "")
      : logo
    : null;

  return logoUrl !== null ? (
    <Avatar src={logoUrl || ""} alt={objectName} aria-label={objectName}>
      {objectName}
    </Avatar>
  ) : (
    <Stack
      align="center"
      justify="center"
      dangerouslySetClassName={styles.dataObjectPlaceholderIcon}
    >
      <App size={16} color={CatalystColors.NEUTRAL_500} />
    </Stack>
  );
};
